import { CustomTheme, themes } from '@masfront/common-b2c'

import { makeStyles, createStyles } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'

import { Brand, getBrandFromThemeName } from '~/brand'
import { deepMerge } from '~/utils'

// renombrar brandStyles
const commonStyles = {
  root: {},
}

const styles = {
  [Brand.masmovil]: deepMerge(commonStyles, {
    root: {
      backgroundColor: themes.masmovil.palette.grey[800],

      '& .account-item-colapse': {
        backgroundColor: themes.masmovil.palette.grey[900],
      },

      '& .list-item-button': {
        '&:hover, &.selected': {
          backgroundColor: themes.masmovil.palette.grey[600],
        },
      },
      '& .list-item-button.product-item': {
        '&:hover, &.selected': {
          backgroundColor: themes.masmovil.palette.grey[700],
        },
      },
      '& .account-sub-menu': {
        backgroundColor: themes.masmovil.palette.grey[900],
      },
      '& .arrow-item': {
        borderColor: `transparent transparent transparent ${themes.masmovil.palette.grey[600]}`,
      },
      '& .list-item-button.product-item.selected .arrow-item': {
        borderColor: `transparent transparent transparent ${themes.masmovil.palette.grey[700]}`,
        '&:hover': {
          borderColor: `transparent transparent transparent ${themes.masmovil.palette.grey[700]}`,
        },
      },
    },
    skeleton: {
      backgroundColor: themes.masmovil.palette.grey[800],
      '& .MuiSkeleton-root': {
        backgroundColor: themes.masmovil.palette.grey[700],
      },
    },
  }),
  [Brand.llamaya]: deepMerge(commonStyles, {
    root: {
      backgroundColor: themes.llamaya.palette.primary.main,

      '& .list-item-button': {
        '&:hover': {
          backgroundColor: themes.llamaya.palette.primary.light,
        },
        '&.selected': {
          backgroundColor: themes.llamaya.palette.primary.light,
        },
      },

      '& .account-sub-menu': {
        backgroundColor: themes.llamaya.palette.primary.dark,
      },
      '& .arrow-item': {
        borderColor: `transparent transparent transparent ${themes.llamaya.palette.primary.light}`,
      },
    },
    skeleton: {
      backgroundColor: themes.llamaya.palette.primary.main,
      '& .MuiSkeleton-root': {
        backgroundColor: fade(themes.llamaya.palette.primary.light, 0.4),
      },
    },
  }),
}

const useBrandStyles = makeStyles((theme: CustomTheme) => {
  const stylesRules = styles[getBrandFromThemeName(theme.name)]

  return createStyles(stylesRules)
})

export default useBrandStyles
